import { css } from '@emotion/react';

type LanguageOptionLabelProps = {
  image: string;
  label: string;
  onClick?: () => void;
};

const LanguageOptionLabel = ({
  image,
  label,
  onClick,
}: LanguageOptionLabelProps) => (
  <div
    tw="flex items-center"
    onClick={onClick}
    data-cy="LanguageOptionLabel_div"
  >
    <div
      tw="w-4 h-4"
      css={css`
        background: url(${image}) no-repeat center center;
        background-size: contain;
      `}
    />
    <div tw="ml-3">{label}</div>
  </div>
);

LanguageOptionLabel.displayName = 'LanguageOptionLabel';

export default LanguageOptionLabel;
